import { render, staticRenderFns } from "./StatisticTopSellProductOfMonth.vue?vue&type=template&id=0215977a&scoped=true"
import script from "./StatisticTopSellProductOfMonth.vue?vue&type=script&lang=js"
export * from "./StatisticTopSellProductOfMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215977a",
  null
  
)

export default component.exports